<template>
  <div id="navigation" class="flex z1">
    <div class="menu-mobile flex-auto my2 xl-hide"><span @click="showMobileMenu = true" class="pointer">Menu</span></div>
    <div class="py2 flex-auto right-align xl-hide capitalize">
      <span v-if="this.$route.name != 'Landing'">{{ pageTitle }}</span>
      <router-link v-if="nextEvent && showSub && this.$route.name == 'Landing'" class="black block" :to="{ name: 'Location', params: { slug: nextEvent.slugs[0] }}">Go to Next Event</router-link>
    </div>

    <ul class="xs-hide sm-hide md-hide lg-hide xl-show list-reset flex-auto" :class="{ m0: !showSub }">
      <li v-if="isHome" class="inline-block"><a href="#" class="black" v-scroll-to="{ el: '#content', duration: 200 }">Locations</a></li>
      <li v-else class="inline-block"><router-link :to="{ name: 'Landing', params: { loc: 'locations' } }">Locations</router-link></li>
      <li class="inline-block"><router-link :class="{ black: this.$route.name == 'About'}" :to="{ name: 'About' }">About</router-link></li>
      <li class="inline-block"><a href="/map" target="_blank">Map</a></li>
      <li class="inline-block"><router-link :to="{ name: 'Gallery' }">Gallery</router-link></li>
      <li class="inline-block"><router-link :class="{ black: this.$route.name == 'Visitor Information'}" :to="{ name: 'Visitor Information' }">Visitor Information</router-link></li>
      <li class="inline-block"><a href="https://prismic-io.s3.amazonaws.com/ftiam/e55cf3e4-8d0b-4b9c-8428-efe3202ca965_FTIAM-Anthology-v2-spread-lines.pdf">Anthology</a></li>
    </ul>

    <div v-if="showSub && this.$route.name == 'Landing'" class="xs-hide sm-hide md-hide lg-hide xl-show flex-auto submenu list-reset flex-auto right-align">
      <router-link v-if="nextEvent" class="black block py2 ml-auto" :to="{ name: 'Location', params: { slug: nextEvent.slugs[0] }}">Go to Next Event</router-link>
    </div>

    <ul class="submenu xs-hide sm-hide md-hide lg-hide xl-show right-align" v-else-if="showSub && this.$route.name == 'Visitor Information'">
      <li class="inline-block">
        <router-link :to="{ name: 'Visitor Information' }">What to Expect</router-link>
      </li>
      <li class="inline-block ml2">
        <router-link :to="{ name: 'Visitor Information', params: { slug: 'learning-resource'} }">Learning Resource</router-link>
      </li>
      <!-- <li class="inline-block ml2"><a href="/map" class="black" target="_blank">Map/Schedule</a></li>   -->
    </ul>

    <ul class="submenu xs-hide sm-hide md-hide lg-hide xl-show right-align" v-else-if="showSub && this.$route.name == 'About'">
      <li class="inline-block"><router-link :to="{ name: 'About' }">The Artwork</router-link></li>
      <li class="inline-block ml1"><router-link :to="{ name: 'About', params: { slug: 'artist'} }">The Artist</router-link></li>
      <li class="inline-block ml1"><router-link :to="{ name: 'About', params: { slug: 'press'} }">Press</router-link></li>
      <li class="inline-block ml1"><router-link :to="{ name: 'About', params: { slug: 'contact'} }">Contact</router-link></li>
      <li class="inline-block ml1"><router-link :to="{ name: 'About', params: { slug: 'acknowledgements'} }">Acknowledgements</router-link></li>
    </ul>

    <transition name="fade">
      <div v-if="showMobileMenu" id="mobile-menu" class="pl3">
        <ul class="mt2 list-reset" @click="showMobileMenu = false">
          <li><a href="#" @click.prevent="showMobileMenu = false">Close</a></li>
          <li class="mt-big"><router-link :to="{ name: 'Landing', meta: { 'scrollToLocations': true }}">Locations</router-link></li>
          <li v-if="nextEvent"><router-link class="black block" :to="{ name: 'Location', params: { slug: nextEvent.slugs[0] }}">Go to Next Event</router-link></li>
          <li><a href="/map" class="black" target="_blank">Map</a></li>
          <li><router-link :to="{ name: 'Gallery' }">Gallery</router-link></li>
          <li>
            <router-link :to="{ name: 'Visitor Information' }">Visitor Information</router-link>
            <!-- <ul>
              <li>
                <router-link :to="{ name: 'Visitor Information' }">What to Expect</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Visitor Information', params: { slug: 'learning-resource'} }">Learning Resource</router-link>
              </li>
            </ul> -->
          </li>
          <li>
            <router-link :to="{ name: 'About' }">About</router-link>
            <ul>
              <li><router-link :to="{ name: 'About' }">The Artwork</router-link></li>
              <li><router-link :to="{ name: 'About', params: { slug: 'artist'} }">The Artist</router-link></li>
              <li><router-link :to="{ name: 'About', params: { slug: 'press'} }">Press</router-link></li>
              <li><router-link :to="{ name: 'About', params: { slug: 'contact'} }">Contact</router-link></li>
              <li><router-link :to="{ name: 'About', params: { slug: 'acknowledgements'} }">Acknowledgements</router-link></li>
            </ul>
          </li>
          <li><a href="https://prismic-io.s3.amazonaws.com/ftiam/3bf3c68c-fc49-430d-8641-c2dbacb65fa4_FTIAM-Anthology-v3-single.pdf">Read the Anthology</a></li>
        </ul>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  name: 'Menu',

  data () {
    return {
      showMobileMenu: false
    }
  },

  props: ['showSub'],

  computed: {
    ...mapGetters([
      'nextEvent'
    ]),
    isHome () {
      return this.$route.name == 'Landing'
    },
    pageTitle () {
      if (this.$route.params.hasOwnProperty('slug') && this.$route.params.slug !== undefined) {
        return this.$route.params.slug.replace('-', ' ')
      } else {
        return this.$route.name
      }
    }
  },

  watch: {
    '$route' () {
      this.showMobileMenu = false
    }
  }
}
</script>

<style lang="css" scoped>
  #navigation {
    ul {
      margin: 0;
      margin-top: var(--space-2);
      margin-bottom: var(--space-2);
    }
    a {
      color: var(--light-grey);

      &.black, &:hover, &.router-link-exact-active {
        color: var(--black);
      }
    }

    &.black {
      a {
        color: var(--black);
      }
    }

    &.sticky {
      background: white;
      border-bottom: 1px solid var(--black);
      position: sticky;
      top: 0;
    }

    li {
      margin-right: 0.3em;

      &:last-child {
        margin-right: 0;
      }
    }

    ul {
      padding-left: 0;
    }
  }

  #mobile-menu {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,0.9);
    backdrop-filter: blur(4px);
    font-size: 24px;
    line-height: 1.6;
    overflow-y: scroll;

    &>ul>li {
      margin-top: 0.5em;
    }

    ul>li>ul {
      margin-left: var(--space-3);
    }

    a {
      color: var(--black);
    }
  }
</style>
